// extracted by mini-css-extract-plugin
module.exports = {"Bonus":"Bonus_Bonus__OKWBP","rule_modal":"Bonus_rule_modal__OiGdj"};